export default "__VITE_ASSET__nly3XTBM__"